import {HelpService} from '../service/help.service';
import {Directive, ElementRef, HostListener, OnInit, Renderer2} from '@angular/core';

@Directive({
    selector: '[wfdssAppHelp]',
    standalone: false
})
export class HelpDirective implements OnInit {
    constructor(private helpService: HelpService, private el: ElementRef, private renderer: Renderer2) {}

    // @HostListener('mouseenter') onMouseEnter() {
    //     const dataId = this.el.nativeElement.getAttribute('data-id');
    //     this.helpService.showHelp(dataId);
    // }

    ngOnInit(): void {
        this.renderer.setAttribute(this.el.nativeElement, 'aria-label', 'tool tip. press enter to open tool tip')
        this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '0')
    }

    @HostListener('click') onMouseClick() {
        const dataName = this.el.nativeElement.getAttribute('data-madcap-id');
        const rect = this.el.nativeElement.getBoundingClientRect();
        this.helpService.showHelp(dataName, rect);
    }
}

